import { defineStore } from 'pinia'
import { computed, ref } from "vue";
import { storage } from "@utils/storage";
import { deepCopy } from "@utils/utils";

export const useUserInfoStore = defineStore('userInfo', () => {
    const userInfo = ref(storage.get('userInfo') || {})

    const isLogin = computed(() => {
        return userInfo.value.accessToken
    })

    /**
     * 更新用户信息
     * @param data 需要更新的数据，只需要传入对应字段和值
     * @param {boolean} cover 是否完全覆盖源数据
     */
    const setUserInfo = (data, cover = false) => {
        let _userInfo = {};
        if (cover) {
            _userInfo = data;
        } else {
            _userInfo = deepCopy(userInfo.value)
            _userInfo = { ..._userInfo, ...data }
        }
        userInfo.value = _userInfo;
        storage.set('userInfo', deepCopy(_userInfo));
    }

    return {
        isLogin,
        userInfo,
        setUserInfo
    }
})
